import CartMixin from '../../../../../../mixins/cart'
// noinspection NpmUsedModulesInstalled
import GiftcardApplyMixin from '../../../../../../mixins/external/giftcard-apply'
import LanguageMixin from '../../../../../../mixins/lang'
import SettingsMixin from '../../../../../../mixins/settings'
import {EventBus, DataFilter} from '../../../../../../lib/utils'

const defaultCostDetailsInfo = {
  price: {
    label: 'Subtotal',
  },
  tax: {
    label: 'Tax',
  },
  price_discount: {
    hideZero: true,
    label: 'Discount',
    showNegative: true,
  },
  discounts: {
    hideZero: true,
    label: 'Gift Card',
    showNegative: true,
  },
  total: {
    label: 'Total',
  },
  remaining: {
    label: 'Remaining amount',
  },
}

export default {
  name: 're-cart-summary',
  mixins: [CartMixin, GiftcardApplyMixin, LanguageMixin, SettingsMixin],
  props: {
    costDetailsInfo: {
      type: Object,
      default: null
    },
    costDetailsOrder: {
      type: Array,
      default: () => (['price', 'tax', 'discounts', 'price_discount', 'total'])
    },
  },

  computed: {
    cartCostDetails() {
      const lang = this.$$t('summary.sections', this.costDetailsInfo || defaultCostDetailsInfo)
      const info = _.merge({}, defaultCostDetailsInfo, lang)
      const sortOrder = this.$$s('summary.sections.$order', this.costDetailsOrder || [])
      const raw = this.costDetails || {}
      const details = sortOrder.reduce((details, key) => {
        const item = info[key]
        let value = raw[key]
        if (item) {
          const isObject = _.isObject(value)
          const isZero = !isObject && !(1 * value)
          let valid = !_.isNil(value)
          if (item.hideZero) {
            valid = !isZero
          }
          if (!isObject) {
            if (item.showNegative) {
              value = -1 * value
            }
          }
          if (valid) {
            details.push({
              ...item,
              key,
              value
            })
          }
        }
        return details
        }
        , [])

      DataFilter.apply('cart.summary.details', details, this.costDetails, this)
      return details
    },
    discountValue() {
      return this.giftcardsDiscount(this.costDetails)
    },
    showDiscountPoint() {
      return this.discountValue < 0
    },
    giftCardList() {
      return this.giftcards(this.costDetails)
    },
    remainingValue() {
      return this.costDetails.deposit > 0 ? this.costDetails.remaining : this.costDetails.total
    }
  },
}
